export const getValuesFromFmlString =(fmlValue,className) =>{
    let result= fmlValue.trim();
    result = result.split(" ");
   let selectedClass=document.getElementsByClassName(className);

   for(let i=0;i<selectedClass.length;i++)
   {
      selectedClass[i].value=result[i];
   }
}